// RefundPolicy.js
import React from 'react';
import './RefundPolicy.css';

const RefundPolicy = () => {
  return (
    <div className="rf-container">
      <div className="rf-header">
        <div className="rf-header-content">
          <h1>Refund Policy</h1>
          <p className="rf-last-updated">Last updated: November 27, 2025</p>
        </div>
      </div>

      <div className="rf-content">
        <div className="rf-nav">
          <h3>Contents</h3>
          <ul>
            <li><a href="#overview">1. Overview</a></li>
            <li><a href="#plans">2. Subscription Plans</a></li>
            <li><a href="#eligibility">3. Eligibility for Refunds</a></li>
            <li><a href="#nonrefundable">4. Non-Refundable Cases</a></li>
            <li><a href="#request">5. How to Request a Refund</a></li>
            <li><a href="#processing">6. Processing of Refunds</a></li>
            <li><a href="#changes">7. Changes to this Policy</a></li>
            <li><a href="#contact">8. Contact Information</a></li>
          </ul>
        </div>

        <div className="rf-main">
          <section id="overview">
            <h2>1. Overview</h2>
            <p>
              At Cayoty, we value our customers and strive to provide reliable,
              high-quality AI-powered presentation and slide generation tools. This Refund Policy
              explains when and how refunds may be issued for subscription fees paid
              through our Service.
            </p>
          </section>

          <section id="plans">
            <h2>2. Subscription Plans</h2>
            <p>
              Our Service offers different subscription tiers with varying features and
              credit limits. By subscribing to any of these plans, you agree to the
              payment and renewal terms outlined in our Terms of Service.
            </p>
          </section>

          <section id="eligibility">
            <h2>3. Eligibility for Refunds</h2>
            <p>Refunds may be considered in the following cases:</p>
            <ul>
              <li>Duplicate charges due to a technical error</li>
              <li>Unauthorized transactions (after investigation)</li>
              <li>
                Failure of the Service to deliver core features as promised, provided
                you notify us within 14 days of purchase
              </li>
            </ul>
          </section>

          <section id="nonrefundable">
            <h2>4. Non-Refundable Cases</h2>
            <p>We generally do not offer refunds for:</p>
            <ul>
              <li>Change of mind after purchase</li>
              <li>Unused credits on active subscriptions</li>
              <li>
                Results not meeting expectations (AI-generated content quality may vary)
              </li>
              <li>Violation of our Terms of Service</li>
            </ul>
          </section>

          <section id="request">
            <h2>5. How to Request a Refund</h2>
            <p>
              To request a refund, please contact our support team at{" "}
              <a href="mailto:support@cayoty.com">support@cayoty.com</a> with
              the following details:
            </p>
            <ul>
              <li>Account email address</li>
              <li>Payment receipt or transaction ID</li>
              <li>Reason for requesting a refund</li>
            </ul>
          </section>

          <section id="processing">
            <h2>6. Processing of Refunds</h2>
            <p>
              Approved refunds will be processed to the original payment method within
              5–10 business days. Processing times may vary depending on your bank or
              payment provider.
            </p>
          </section>

          <section id="changes">
            <h2>7. Changes to this Policy</h2>
            <p>
              We may update this Refund Policy from time to time. Changes will be
              effective immediately upon posting on this page. Continued use of the
              Service after changes are made constitutes acceptance of the updated
              policy.
            </p>
          </section>

          <section id="contact">
            <h2>8. Contact Information</h2>
            <p>If you have any questions about this Refund Policy, please contact us at:</p>
            <div className="rf-contact-info">
              <p>Email: legal@cayoty.com</p>
             
            </div>
          </section>

          <div className="rf-footer">
            <p>
              This Refund Policy applies in conjunction with our Terms of Service and
              Privacy Policy. By subscribing to our Service, you acknowledge and agree
              to the conditions outlined above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;